module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C289"
  }, [_c('em', [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("Illustrations")])])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('p', {
    staticClass: "C284"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/02_Frontispiece#page_ii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frontispiece: Hieronymus Bosch, "), _c('em', [_vm._v("The Garden of Earthly Delights")])])]), _vm._v(" "), _c('p', {
    staticClass: "C284"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Introduction__On_Wild_Facts_and#id_1764"
    }
  }, [_vm._v("1. The first brochure")])]), _vm._v(" "), _c('p', {
    staticClass: "C284"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13_1__Slate_s_Hot_Springs__Homestea#id_1765"
    }
  }, [_vm._v("2. Henry Miller at the baths")])]), _vm._v(" "), _c('p', {
    staticClass: "C284"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/15_2__The_Professor_and_the_Saint#page_54"
    }
  }, [_vm._v("3. Frederic Spiegelberg")])]), _vm._v(" "), _c('p', {
    staticClass: "C284"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/15_2__The_Professor_and_the_Saint#page_58"
    }
  }, [_vm._v("4. Dennis and Michael Murphy")])]), _vm._v(" "), _c('p', {
    staticClass: "C284"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_3__Buddhism__Breakdown__Breakthr#id_1766",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Richard Price and Michael Murphy")])]), _vm._v(" "), _c('p', {
    staticClass: "C284"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_4___Totally_on_Fire___The_Experi#page_98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The first staff")])]), _vm._v(" "), _c('p', {
    staticClass: "C284"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_4___Totally_on_Fire___The_Experi#page_100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. The original mission statement")])]), _vm._v(" "), _c('p', {
    staticClass: "C284"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_4___Totally_on_Fire___The_Experi#id_1767",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Poster of the fifth Big Sur Folk Festival")])]), _vm._v(" "), _c('p', {
    staticClass: "C284"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_4___Totally_on_Fire___The_Experi#id_1768",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Ravi Shankar and George Harrison on the front lawn")])]), _vm._v(" "), _c('p', {
    staticClass: "C284"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_5__Mind_Manifest__Psychedelia_at#page_114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. “Mexican Transmission”")])]), _vm._v(" "), _c('p', {
    staticClass: "C284"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_6__Mesmer_to_Maslow__Energy_and#id_1769",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Abraham Maslow")])]), _vm._v(" "), _c('p', {
    staticClass: "C284"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_7__Perls_to_Price__Consciousness#id_1770",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Fritz Perls")])]), _vm._v(" "), _c('p', {
    staticClass: "C284"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_7__Perls_to_Price__Consciousness#id_1771",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Dick Price working with Julian Silverman")])]), _vm._v(" "), _c('p', {
    staticClass: "C284"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_7__Perls_to_Price__Consciousness#id_1772",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. Claudio Naranjo")])]), _vm._v(" "), _c('p', {
    staticClass: "C284"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_8__Esalen_Goes_to_the_City__The#page_184",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. Price Cobbs and George Leonard")])]), _vm._v(" "), _c('p', {
    staticClass: "C284"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_8__Esalen_Goes_to_the_City__The#page_188",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. Joseph Campbell celebrating a birthday at Esalen")])]), _vm._v(" "), _c('p', {
    staticClass: "C284"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_8__Esalen_Goes_to_the_City__The#id_1773",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. Alan Watts, Steve Stroud, John Heider, and Will Schutz")])]), _vm._v(" "), _c('p', {
    staticClass: "C284"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_9__On_Ecstasy__Education__and_th#page_207",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. "), _c('em', [_vm._v("Look")]), _vm._v(" magazine feature photo of Michael Murphy")])]), _vm._v(" "), _c('p', {
    staticClass: "C284"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_10__The_Serpent_Spine_of_Spirit#id_1774",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. Don Hanlon Johnson, Charlotte Selver, and Charles Brooks")])]), _vm._v(" "), _c('p', {
    staticClass: "C284"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_11__The_Cosmic_Womb__Stanislav_a#id_1775",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. Christina and Stanislav Grof")])]), _vm._v(" "), _c('p', {
    staticClass: "C284"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_13__Jacob_Atabet_and_the_Tantra#page_301",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. Original “quantum” cover of "), _c('em', [_vm._v("Jacob Atabet")])])]), _vm._v(" "), _c('p', {
    staticClass: "C284"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_13__Jacob_Atabet_and_the_Tantra#id_1776",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. Chungliang Al Huang")])]), _vm._v(" "), _c('p', {
    staticClass: "C284"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_14__Superpowers__Cold_War_Psychi#id_1777",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23. James Hickman and Joseph Montville")])]), _vm._v(" "), _c('p', {
    staticClass: "C284"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_14__Superpowers__Cold_War_Psychi#id_1778",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24. Joseph Goldin and Richard Baker Roshi")])]), _vm._v(" "), _c('p', {
    staticClass: "C284"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_14__Superpowers__Cold_War_Psychi#id_1779",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25. Hidden Human Reserves logo created by Joseph Goldin")])]), _vm._v(" "), _c('p', {
    staticClass: "C284"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_14__Superpowers__Cold_War_Psychi#id_1780",
      "id": "page_x",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26. Apollo IX astronaut Rusty Schweickart and Russian psychic healer Dzhuna Davitashvili")])]), _vm._v(" "), _c('p', {
    staticClass: "C284"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_16__The_Tao_of_Esalen__The_Spiri#id_1781",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27. Michael Murphy, Richard Price, Christine Price, and Dulce Murphy")])]), _vm._v(" "), _c('p', {
    staticClass: "C284"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_16__The_Tao_of_Esalen__The_Spiri#id_1782",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28. Gordon Wheeler and Nancy Lunney-Wheeler")])]), _vm._v(" "), _c('p', {
    staticClass: "C284"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33_17__The_Religion_of_No_Religion#id_1783",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29. Steve Donovan reading Aldous Huxley")])]), _vm._v(" "), _c('p', {
    staticClass: "C284"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/36_19__After_the_Storm__Reassessmen#id_1784",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30. Steve Donovan’s sloop named Yoni")])]), _vm._v(" "), _c('p', {
    staticClass: "C284"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/36_19__After_the_Storm__Reassessmen#id_1785",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31. The Big House")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72b79a2c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08_Illustrations.vue
// module id = 75
// module chunks = 0